<template>
	<div class="userList column-me">
		<div class="card-view column-me">
			<div class="card-title">系统激活码列表</div>
			<div class="row-me row-center">
				<div class="width300 demo-input-size">
					<el-input placeholder="激活码"  style="width: 100%;" v-model="agentcode" :prefix-icon="Search"></el-input>
				</div>
				<el-form-item label="激活码状态"  class="margin-left30 margin-top20 width200">
					<el-select v-model="isCodeStatusSearch" placeholder="激活码状态">
						<el-option
							v-for="item in codeStatusOptionSearch" 
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="代理" class="margin-left30 margin-top20 width300">
					<el-popover :width="480" placement="bottom-start"  trigger="focus">
						<template #reference>
							<el-input v-model="agent_secKeyword" @input="agentSystemSearchList()" :focus="agent_secTableBoxOpen" placeholder="代理名称/联系人/手机号"></el-input>
						</template>
						<el-table :data="agent_secData" v-loading="agent_secloading" v-model="agent_secTableBox" size="large" :highlight-current-row="true" @row-click="agent_secSelected">
							<el-table-column width="150" align="center" property="lecturer_name" label="代理名称" />
							<el-table-column width="150" align="center" property="username" label="联系人" />
							<el-table-column width="150" align="center" property="phone" label="手机号" />
						</el-table>
					</el-popover>
				</el-form-item>
				<el-form-item label="学生"  class="margin-left30 margin-top20 width300">
					<el-popover :width="480" placement="bottom-start"  trigger="focus">
						<template #reference>
							<el-input v-model="userKeyword" @input="userSystemSearchList()" :focus="userTableBoxOpen" placeholder="昵称/姓名/手机号"></el-input>
						</template>
						<el-table :data="userData" v-loading="userloading" v-model="userTableBox" size="large" :highlight-current-row="true" @row-click="userSelected">
							<el-table-column width="150" align="center" property="nickname" label="昵称" />
							<el-table-column width="150" align="center" property="name" label="姓名" />
							<el-table-column width="150" align="center" property="phone" label="手机号" />
						</el-table>
					</el-popover>
				</el-form-item>
				<el-button class="margin-left20" type="primary" size="mini " @click="clickSearch" >搜索</el-button>
				<el-button size="mini " @click="clickClear" >重置</el-button>
				<el-button v-if="acctype == 1" type="danger" size="mini" @click="clickAdd" >新增</el-button>
			</div>
			<div class="column-me flex1 overflow-auto">
				<div class="flex1 overflow-auto">
					<el-table :data="tableData" border v-loading="loading" stripe="true" size="medium" style="width: 100%" height="100%">
						<el-table-column v-if="acctype < 3" prop="TcAgentInfo.lecturer_name" label="所属代理商" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="mold" label="激活码类型" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-tag v-if="scope.row.mold == 1" effect="dark" type="danger">主科兑换码</el-tag>
								<el-tag v-if="scope.row.mold == 2" effect="dark">副科兑换码</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="code" label="激活码" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="status" label="激活码状态" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-tag v-if="scope.row.status == 1" effect="dark" type="success">未使用</el-tag>
								<el-tag v-if="scope.row.status == 2" effect="dark" type="danger">已使用</el-tag>
								<el-tag v-if="scope.row.status == 3" effect="dark" type="info">已过期</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="special_title" label="兑换课程" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="user_nickname" label="学员名称" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="start_time" label="有效期开始" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="end_time" label="有效期结束" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column v-if="acctype == 1" label="操作" width="200px" align="center" show-overflow-tooltip fixed="right">
							<template #default="scope">
								<div class="row-me center-all">
									<el-button v-if="scope.row.status <= 2" size="small" @click="clickEdit(scope.row)">修改</el-button>
									<el-button type="primary" size="small" @click="clickRevocation(scope.row)">撤销</el-button>
									<el-button type="danger" v-if="scope.row.status != 2" size="small " @click="clickDel(scope.row)" >删除</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="margin-top20">
					<el-pagination @current-change="handleCurrentChange" background :current-page.sync="pageNo"
                         layout="total, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
	<!-- 激活码信息添加界面 -->
	<el-dialog title="激活码信息添加" v-model="codeInfoAdd" :show-close="false" width="1200px" top="10vh" :destroy-on-close="true">
	    <div class="padding-left80">
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>激活码类型：</div>
				<div class="width500">
					<el-radio v-model="codeAddInfoArr.mold" :label="1">主科</el-radio>
					<el-radio v-model="codeAddInfoArr.mold" :label="2">副科</el-radio>
				</div>
			</div>
			<div class="row-me row-center margin-top20" >
				<div class="left-title"><span class="red-star">*</span>代理商选择：</div>
				<div class="width500">
					<el-popover :width="480" placement="bottom-start"  trigger="focus">
					    <template #reference>
							<el-input v-model="agent_secKeyword" @input="agentSystemSearchList()" :focus="agent_secTableBoxOpen" placeholder="代理名称/联系人/手机号"></el-input>
					    </template>
					    <el-table :data="agent_secData" v-loading="agent_secloading" v-model="agent_secTableBox" size="large" :highlight-current-row="true" @current-change="agent_secSelected">
					        <el-table-column width="150" align="center" property="lecturer_name" label="代理名称" />
					        <el-table-column width="150" align="center" property="username" label="联系人" />
					        <el-table-column width="150" align="center" property="phone" label="手机号" />
					    </el-table>
					</el-popover>
				</div>
			</div>
	        <div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>数量：</div>
				<div class="width500">
					<el-input-number placeholder="请输入" size="mini" :min="1" clearable v-model="codeAddInfoArr.code_num"></el-input-number>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>有效期开始：</div>
				<div class="width500">
					<el-date-picker 
						placeholder="选择日期" 
						size="mini" 
						type="date"
						style="width: 100%;" 
						clearable 
						v-model="codeAddInfoArr.start_time"></el-date-picker>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>有效期结束：</div>
				<div class="width500">
					<el-date-picker placeholder="选择日期" type="date" style="width: 100%;" clearable v-model="codeAddInfoArr.end_time"></el-date-picker>
				</div>
			</div>
	        <div class="row-me flex-end1 margin-top50">
				<el-button @click="codeInfoAddClosed">取消</el-button>
				<el-button type="primary" @click="codeAddClickSave">确定</el-button>
	        </div>
	    </div>
	</el-dialog>
	<!-- 激活码信息修改界面 -->
	<el-dialog title="激活码起止日期修改" v-model="codeInfoEdit" :show-close="false" width="900px" top="10vh" :destroy-on-close="true">
	    <el-descriptions title="" colon="true" style="width: 100%;" :column = "3" border>
	      	<el-descriptions-item label="代理商">{{codeEditInfoArr.TcAgentInfo.lecturer_name}}</el-descriptions-item>
	      	<el-descriptions-item label="激活码">{{codeEditInfoArr.code}}</el-descriptions-item>
	      	<el-descriptions-item label="类型">
	    		<el-tag v-if="codeEditInfoArr.mold == 1" effect="dark" type="danger">主科兑换码</el-tag>
	    		<el-tag v-if="codeEditInfoArr.mold == 2" effect="dark">副科兑换码</el-tag>
	    	</el-descriptions-item>
	    	<el-descriptions-item label="状态">
	    		<el-tag v-if="codeEditInfoArr.status == 1" effect="dark" type="success">未使用</el-tag>
	    		<el-tag v-if="codeEditInfoArr.status == 2" effect="dark" type="danger">已使用</el-tag>
	    		<el-tag v-if="codeEditInfoArr.status == 3" effect="dark" type="info">已过期</el-tag>
	    	</el-descriptions-item>
	    	<el-descriptions-item label="兑换课程">{{codeEditInfoArr.special_title}}</el-descriptions-item>
	    	<el-descriptions-item label="使用学员">{{codeEditInfoArr.user_nickname}}</el-descriptions-item>
	    </el-descriptions>
		<div class="row-me row-center margin-top20">
			<div class="left-title"><span class="red-star">*</span>有效期开始：</div>
			<div class="width500">
				<el-date-picker 
					placeholder="选择日期" 
					size="mini" 
					type="date"
					style="width: 100%;" 
					clearable 
					v-model="codeEditInfoArr.start_time"></el-date-picker>
			</div>
		</div>
		<div class="row-me row-center margin-top20">
			<div class="left-title"><span class="red-star">*</span>有效期结束：</div>
			<div class="width500">
				<el-date-picker placeholder="选择日期" type="date" style="width: 100%;" clearable v-model="codeEditInfoArr.end_time"></el-date-picker>
			</div>
		</div>
	    <div class="row-me flex-end1 margin-top50">
	    	<el-button @click="codeInfoEditClosed">取消</el-button>
	    	<el-button type="primary" @click="codeEditClickSave">确定</el-button>
	    </div>
	</el-dialog>
</template>
<script>
import {Plus,Search} from "@element-plus/icons";
import { tr } from "element-plus/es/locale";
export default {
  components: {Plus,Search},
  data() {
    return {
		acctype:null,
		keyword: '',
		agentcode:'',
		pageNo: 1,
		total: 0,
		loading:false,
		tableData: [],
		tableSelectData:[],
		isCodeClassSearch:'',
		codeClassOptionSearch:[{
			value: 1,
			label: '总部',
		},{
			value: 2,
			label: '代理商',
		}],
		isCodeStatusSearch:'',
		codeStatusOptionSearch:[{
			value: 1,
			label: '未使用',
		},{
			value: 2,
			label: '已使用',
		},{
			value: 3,
			label: '已过期',
		}],
		codeInfoAdd:false,
		codeAddInfoArr:{
			agent_id:0,
			mold:1,
			code_num:0,
			start_time:'',
			end_time:'',
			agentLecturerName:''
		},
		agentSelect:false,
		
		codeInfoEdit:false,
		codeEditInfoArr:{
			TcAgentInfo: {
				id: 0, 
				lecturer_name: '',
			},
			agent_id: 0,
			code: '',
			end_time: '',
			id: 0,
			is_del: 0,
			mold: 2,
			special_title: '',
			start_time: '',
			status: 2,
			type: 1,
			userSpecialInfo: {
				user_id: 0, 
				special_id: 0,
			},
			user_id: 0,
			user_nickname: '',
		},
		//代理商检索table
		//代理商输入框弹窗table表格检索
		agent_sec_id:0,
		agent_secKeyword:'',
		agent_secData:null,
		agent_secTableBox:false,
		agent_secloading:false,
		// agentData:null,
		// agentTableBox:false,
		// agentloading:false,
		
		//代理商输入框弹窗table表格检索
		user_id:0,
		userKeyword:'',
		userData:null,
		userTableBox:false,
		userloading:false,
    }
  },
  // 侦听器
  watch: {},
	// 计算属性
	computed: {
		Search() {
			return Search
		}
	},
	// html加载完成之前
	created() {
		this.acctype = sessionStorage.getItem('acctype');
		this.clickSearch()
	},
  // html加载完成后执行。
  mounted() {
		this.userSystemSearchList();
		this.agentSystemSearchList();
  },
  // 事件方法执行
  methods: {
	  
	clickSearch() {
		this.userSystemSearchList();
		this.agentSystemSearchList();
		this.pageNo = 1
		this.getData()
    },
    clickClear() {
		this.isCodeClassSearch = '';
		this.isCodeStatusSearch = '';
		this.userKeyword = '';
		this.user_id = 0;
		this.agent_secKeyword='';
		this.agent_sec_id = 0;
		this.clickSearch();
    },
    //激活码分类监听
	codeTypeChangeBlock(){
		this.agentSelect = true;
	},
	codeTypeChangeNone(){
		this.agentSelect = false;
		this.codeAddInfoArr.agent_id = "";
		this.codeAddInfoArr.agentLecturerName = "";
	},
	//==================================学员检索======================================
	//学员检索table数据
	userSystemSearchList(){
		this.userloading = true;
		this.$post('/admin/userSystemSearchList', {
			keyword: this.userKeyword,
		}).then((res) => {
			if (res) {
				this.userData = res.data;
				this.userloading = false;
			}
		}).catch((error) => {
			console.log(error)
		})
	},
	//学员检索选中
	userSelected(row){
		this.userKeyword = row.nickname;
		this.user_id = row.id;
		this.userTableBox = false;
		this.getData();
	},
	userTableBoxOpen(){
		this.userTableBox = true;
	},
	
	//==================================代理检索======================================
	//代理检索table数据
	agentSystemSearchList(){
		console.log(this.agent_secKeyword);
		this.agent_secloading = true;
		this.$post('/admin/agentSystemSearchList', {
			keyword: this.agent_secKeyword,
		}).then((res) => {
			if (res) {
				console.log(res.data);
				this.agent_secData = res.data;
				this.agent_secloading = false;
			}
		}).catch((error) => {
			console.log(error)
		})
	},
	//代理检索选中
	agent_secSelected(row){
		//console.log(row);
		this.agent_secKeyword = row.lecturer_name;
		this.agent_sec_id = row.id;
		this.codeAddInfoArr.agent_id = row.id;
		this.agent_secTableBox = false;
		
		//console.log(this.agent_sec_id);
		this.getData();
	},
	agent_secTableBoxOpen(){
		this.agent_secTableBox = true;
	},
	
	clickAdd(){
		this.codeInfoAdd = true;
	},
	//激活码添加弹窗取消按钮事件
	codeInfoAddClosed(){
		this.codeAddInfoArr.agent_id = "";
		this.codeAddInfoArr.agentLecturerName = "";
		this.codeInfoAdd = false;
	},
	//列表分页
	handleCurrentChange(pageNo) {
	    this.pageNo = pageNo
	    this.getData()
	},
	//新增信息保存
	codeAddClickSave(){
		const dataInfo = {
			mold:this.codeAddInfoArr.mold,
			agent_id:this.codeAddInfoArr.agent_id,
			code_num:this.codeAddInfoArr.code_num,
			start_time:this.codeAddInfoArr.start_time,
			end_time:this.codeAddInfoArr.end_time,
		}
		this.$post('/admin/agentCodeAdd', dataInfo).then((res) => {
			if (res) {
				this.clickClear();
				this.codeInfoAdd = false;
				this.$message.success('添加成功');
				this.codeAddInfoArr = {
					agent_id:0,
					type:'1',
					code_num:0,
					start_time:'',
					end_time:'',
					agentLecturerName:''
				};
			}
		}).catch((error) => {
			console.log(error)
		})
	},
	//删除
	clickDel(item) {
		this.$confirm("您确定删除吗？删除后无法恢复！", "温馨提示", {
		    confirmButtonText: "确定",
		    cancelButtonText: "取消",
		    type: "warning",
		}).then(() => {
		    this.$post('/admin/agentCodeDel', {
		        id: item.id
		    }).then((res) => {
		        if (res) {
		            this.$message.success('删除成功')
		            this.getData()
		        }
		    }).catch((error) => {
		        console.log(error)
		    })
		}).catch((error) => {
				console.log(error)
		});	
	},
	//激活码修改
	clickEdit(rowInfo){
		console.log(rowInfo);
		this.codeEditInfoArr = rowInfo;
		this.codeInfoEdit = true;
	},
	//激活码添加弹窗取消按钮事件
	codeInfoEditClosed(){
		this.codeInfoEdit = false;
	},
	//激活码起止日期修改提交
	codeEditClickSave(){
		const postData = {
			id:this.codeEditInfoArr.id,
			start_time:this.codeEditInfoArr.start_time,
			end_time:this.codeEditInfoArr.end_time
		}
		this.$post('/admin/agentCodeEdit', postData).then((res) => {
		    if (res) {
		        this.$message.success('修改成功');
				this.codeInfoEdit = false;
		        this.getData()
		    }
		}).catch((error) => {
		    console.log(error)
		})
	},
	//激活码撤销，用于客户兑换错课程，撤销使用
	clickRevocation(item){
		this.$confirm("您确定撤销吗？撤销后关联信息会删除，无法恢复", "温馨提示", {
		    confirmButtonText: "确定",
		    cancelButtonText: "取消",
		    type: "warning",
		}).then(() => {
		    this.$post('/admin/agentCodeRevocation', {
		        id: item.id
		    }).then((res) => {
		        if (res) {
		            this.$message.success('撤销成功')
		            this.getData()
		        }
		    }).catch((error) => {
		        console.log(error)
		    })
		}).catch((error) => {
				console.log(error)
		});	
	},
    //table获取数据
    getData() {
		this.loading = true;
		this.$post('/admin/agentCodeList', {
			agentcode: this.agentcode,
			status: this.isCodeStatusSearch,
			user_id: this.user_id,
			agent_id:this.agent_sec_id,
			page: this.pageNo
		}).then((res) => {
			if (res) {
				this.total = res.data.all_info_num
				this.tableData = res.data.listInfo
				this.loading = false;
			}
		}).catch((error) => {
			console.log(error)
		})
    },
  },
}
</script>

<style lang="scss" scoped>
.userList {
	height: 100%;
	.img-header {
		width: 60px;
		height: 60px;
		border-radius: 50%;
	}
	.display-box{
		display: none;
	}
}
</style>
